<ng-template #reportCell let-row let-value="value">
  <span
    class="download-report"
    [title]="value"
    (click)="$event.stopPropagation(); downloadReport(row)"
  >
    <span class="material-symbols-outlined"> &#xf090; </span>
    <span>{{ value }}</span>
  </span>
</ng-template>

<div class="header">
  <div class="header-left">
    <h3>{{ reportName }}</h3>
    <a (click)="backToReport()" tabindex="0" (keydown.enter)="backToReport()" class="back-link"
      >&lt;&lt;&nbsp;{{ 'common.backTo' | translate }}
      <span id="prev-url-name">{{ 'Reporting.find.reports' | translate }}</span></a
    >
  </div>
  @if (reportName !== 'Monthly Profitability Report') {
    <div class="dropdown" ngbDropdown #generateReportDropdown="ngbDropdown">
      <button
        class="button button-green"
        ngbDropdownToggle
        data-bs-auto-close="outside"
        tabindex="0"
        id="generateReportButton"
      >
        <span class="material-symbols-outlined">&#xe104;</span>
        {{ 'Reporting.find.generateReport' | translate }}
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <div class="input-container">
          <label for="generateDate">{{ 'Reporting.find.date' | translate }}</label>
          <input type="date" id="generateDate" [(ngModel)]="manualReportDate" [max]="today" />
        </div>
        <div class="dropdown-buttons">
          <button
            class="button button-clear button-small"
            (click)="generateReportDropdown.close()"
            tabindex="0"
            (keydown.enter)="generateReportDropdown.close()"
          >
            {{ 'common.cancel' | translate }}
          </button>
          <button
            class="button button-pink button-small"
            (click)="generateSelectedDateReport(); generateReportDropdown.close()"
            tabindex="0"
            (keydown.enter)="generateSelectedDateReport(); generateReportDropdown.close()"
          >
            {{ 'Reporting.find.generate' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>

<app-table></app-table>
